module.exports = __webpack_public_path__ + "img/no-img-video.e15757db.png";